import {Box, IconButton, Typography} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid-pro';
import FilterTextField from '../../../../common/arr-data-grid-pro/filter-components/text-field/FilterTextField';
import {t} from 'i18next';
import './JobResultDataGrid.scss';
import {ReactComponent as RightChevron} from '../../../../../assets/images/chevron-right.svg';
import {ReactComponent as Warning} from '../../../../../assets/images/warning.svg';
import {IAIReviewJobResultDocsListResponse} from '../../../../../api/types/aiReview.type';

export const getViewByDocsColumns = (
  onDocIdClick?: (documentId: number, docId: number) => void,
  onDocDetailsClick?: (
    documentId: number,
    docId: number,
    reviewJobSubmittedId: number
  ) => void,
  docsResponse?: IAIReviewJobResultDocsListResponse
): GridColDef[] => [
  {
    field: 'docId',
    headerName: t('ai.review.jobTypeDataGrid.viewByDocsColumns.docId'),
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 280,
    renderHeader: () => (
      <Typography
        tabIndex={0}
        className="typo-text label2_size"
        role="columnheader"
        data-testid="view-by-docs-column-doc-id-header"
      >
        {t('ai.review.jobTypeDataGrid.viewByDocsColumns.docId')}
      </Typography>
    ),
    renderCell: (params) => {
      const isClickable = Boolean(params.value);
      return (
        <Box
          tabIndex={0}
          role="gridcell"
          data-testid={`view-by-docs-column-doc-id-${params.id}-box`}
        >
          <Typography
            className={`cell-content typo-text subhead5_size ${
              isClickable ? 'job-value' : 'no_typo_text'
            }`}
            data-testid={`view-by-docs-column-doc-id-${params.id}`}
            onClick={
              isClickable
                ? () => onDocIdClick?.(params.row.documentId, params.row.docId)
                : undefined
            }
            role={isClickable ? 'button' : undefined}
            tabIndex={isClickable ? 0 : undefined}
            onKeyDown={
              isClickable
                ? (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onDocIdClick?.(
                        params.row.documentId,
                        Number(params.row.docId)
                      );
                    }
                  }
                : undefined
            }
          >
            {params.value}
          </Typography>
        </Box>
      );
    },
    renderHeaderFilter: (params) => (
      <FilterTextField
        dataTestId="view-by-docs-doc-id-filter"
        gridRenderHeaderFilterProps={params}
        placeholder={t('common.filter')}
      />
    ),
  },
  {
    field: 'issueCodeMatchedCount',
    headerName: t('ai.review.jobTypeDataGrid.viewByDocsColumns.issueCodes'),
    minWidth: 220,
    flex: 1,
    sortable: true,
    filterable: false,
    renderHeader: () => (
      <Typography
        tabIndex={0}
        role="columnheader"
        className="typo-text label2_size"
        data-testid="view-by-docs-column-issue-codes-header"
      >
        {t('ai.review.jobTypeDataGrid.viewByDocsColumns.issueCodes')}
      </Typography>
    ),
    renderCell: (params) => (
      <Box
        tabIndex={0}
        role="gridcell"
        data-testid={`view-by-docs-column-issue-codes-${params.id}-box`}
      >
        <Typography
          className="typo-text body3_size cell-content"
          data-testid={`view-by-docs-column-issue-codes-${params.id}`}
        >
          {`${params.value} / ${
            docsResponse?.totalIssuCodeCount ??
            docsResponse?.totalIssueCodeCount ??
            0
          }`}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'flag',
    headerName: t('ai.review.jobTypeDataGrid.viewByDocsColumns.flags'),
    sortable: false,
    filterable: false,
    minWidth: 280,
    flex: 1,
    renderHeader: () => (
      <Typography
        tabIndex={0}
        className="typo-text label2_size "
        role="columnheader"
        data-testid="view-by-docs-column-flags-header"
      >
        {t('ai.review.jobTypeDataGrid.viewByDocsColumns.flags')}
      </Typography>
    ),
    renderCell: (params) => {
      return (
        <Box
          tabIndex={0}
          role="gridcell"
          data-testid={`view-by-docs-column-flags-${params.id}-box`}
          className="flag-style"
        >
          {params.row.isFlaggedForHumanReview && (
            <>
              <Warning />
              <Typography
                className="cell-content typo-text body3_size"
                data-testid={`view-by-docs-column-flags-${params.id}`}
              >
                {t(
                  'ai.review.jobTypeDataGrid.viewByDocsColumns.flaggedForReview'
                )}
              </Typography>
            </>
          )}
        </Box>
      );
    },
  },
  {
    field: 'navigate',
    headerName: '',
    filterable: false,
    sortable: false,
    width: 48,
    disableColumnMenu: true,
    renderCell: (params) => (
      <Box className="chevron-icon">
        <IconButton
          size="small"
          aria-label={t(
            'ai.review.jobTypeDataGrid.viewByDocsColumns.docDetails'
          )}
          data-testid={`view-by-docs-column-nav-${params.id}`}
          onClick={(event) => {
            event.stopPropagation();
            onDocDetailsClick?.(
              params.row.documentId,
              params.row.docId,
              params.row.reviewJobSubmittedId
            );
          }}
        >
          <RightChevron />
        </IconButton>
      </Box>
    ),
  },
];
